// PopulationPyramidChart.jsx
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

// Register chart components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function PopulationPyramidChart({ chartData }) {
  // Labels for Y-axis (age groups)
  const ageLabels = ["18-25", "26-35", "36-45", "46-55", "56-65", "66-75", "76+"];

  const numberValue = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const maleData = ageLabels.map((label) => {
    const key = `male_${label.replace("+", "_to_85").replace("-", "_to_")}`;
    return -1 * numberValue(chartData?.[key]);
  });

  const femaleData = ageLabels.map((label) => {
    const key = `female_${label.replace("+", "_to_85").replace("-", "_to_")}`;
    return numberValue(chartData?.[key]);
  });

  const all = [...maleData, ...femaleData];

  const maxAge = all.reduce((acc, val) => {
    return Math.abs(val) > Math.abs(acc) ? val : acc;
  }, all[0]);

  const roundUpToNext = (num, base = 5) => Math.ceil(num / base) * base;

  const maxPositiveAgeForGraph = Math.max(roundUpToNext(Math.abs(maxAge) + 10), 10);
  const maxNegativeAgeForGraph = -maxPositiveAgeForGraph;

  const data = {
    labels: ageLabels,
    datasets: [
      {
        label: "Men",
        data: maleData,
        backgroundColor: "#57c1e8",
      },
      {
        label: "Women",
        data: femaleData,
        backgroundColor: "#ec6b74",
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const value = Math.abs(context.raw);
            return `${label}: ${value}`;
          },
        },
      },
    },
    scales: {
      x: {
        min: maxNegativeAgeForGraph,
        max: maxPositiveAgeForGraph,
        ticks: {
          callback: function (value) {
            return Math.abs(value);
          },
        },
      },
      y: {
        stacked: true,
      },
    },
  };

  return (
    <div style={{ width: "100%", maxWidth: 700, marginBottom: "30px" }}>
      <h3 className="text-lg font-bold mb-4">AGE & GENDER DISTRIBUTION OF LITIGANTS INTERVIEWED</h3>
      <p>
        Of the litigants interviewed, men between 26-35 years and women between 36-45 years formed
        the bulk of the respondents
      </p>
      <Bar data={data} options={options} chartData={chartData} />
    </div>
  );
}
